import { ThemeProvider } from '@mui/material/styles'
import React, { ReactElement } from 'react'
import { Provider } from 'react-redux'
import ErrorMessageProvider from './libs/ErrorMessageProvider'
import store from './store'
import theme from './theme'

interface Props {
  children: ReactElement
}

function AppContext(props: Props) {
  const { children } = props

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ErrorMessageProvider>{children}</ErrorMessageProvider>
      </Provider>
    </ThemeProvider>
  )
}

export default AppContext
